// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__vYOgB","left":"style_left__H_Dci","right":"style_right__dg9ij"};